var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationPhoneText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 10c-2.206 0-4 1.794-4 4v52c0 2.206 1.794 4 4 4h26c2.206 0 4-1.794 4-4V14c0-2.206-1.794-4-4-4H27zm26 62H27c-3.309 0-6-2.691-6-6V14c0-3.309 2.691-6 6-6h26c3.309 0 6 2.691 6 6v52c0 3.309-2.691 6-6 6z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 62h26V20H27v42zm-2 2h30V18H25v46zM38 68h4v-2h-4zM33 15h2v-2h-2zM37 15h10v-2H37z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M31 58h2v-2h-2zM35 58h2v-2h-2zM39 58h2v-2h-2zM43 58h2v-2h-2zM47 58h2v-2h-2zM31 26h2v-2h-2zM35 26h2v-2h-2zM39 26h2v-2h-2zM43 26h2v-2h-2zM47 26h2v-2h-2zM31 31h2v-2h-2zM35 31h2v-2h-2zM39 31h2v-2h-2zM43 31h2v-2h-2zM47 31h2v-2h-2zM31 36h2v-2h-2zM35 36h2v-2h-2zM39 36h2v-2h-2zM43 36h2v-2h-2zM47 36h2v-2h-2zM31 41h2v-2h-2zM35 41h2v-2h-2zM39 41h2v-2h-2zM43 41h2v-2h-2zM47 41h2v-2h-2zM31 46h2v-2h-2zM35 46h2v-2h-2zM39 46h2v-2h-2z",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

export default SvgIconIllustrationPhoneText;